export function FullScreenLoader() {
  return (
    <div
      className="flex h-dvh items-center justify-center"
      style={{ backgroundColor: "var(--ground, #fafaf8)" }}
    >
      <img
        src="/wonda-icon-ink.svg"
        alt=""
        className="size-12"
        aria-hidden="true"
      />
    </div>
  );
}
